import { Grid } from "@mui/material";
import { Top5Words } from "src/components/chart/charts";
import DashboardAreaChart from "../dashboard-area-chart";
import { AreaChartByKeyword } from "src/types/types";
import { useState } from "react";

const DashboardAreaChartByKeyword = ({ data }: { data: AreaChartByKeyword }) => {
  // #region Hooks and states
  const [selectedKeyword, setSelectedKeyword] = useState<null | string>();

  const groupedDataByKeyword = data.content.reduce((acc, item) => {
    if (!acc[item.keyword]) {
      acc[item.keyword] = { text: item.keyword, value: 0 };
    }
    acc[item.keyword].value += item.count;
    return acc;
  }, {} as Record<string, { text: string; value: number }>);

  const groupedDataArr = Object.values(groupedDataByKeyword).sort((a, b) => b.value - a.value);
  // #endregion States and hooks

  // #region Handlers
  const handleWordClick = (keyword: string) => {
    if (selectedKeyword === keyword) {
      setSelectedKeyword(null);
    } else {
      setSelectedKeyword(keyword);
    }
  };
  // #endregion Handlers

  return (
    <Grid container>
      <Grid item xs={12} md={8}>
        <DashboardAreaChart
          data={{
            title: data?.title,
            content: {
              xAxis: data?.content
                .filter((item) => (!selectedKeyword ? true : item.keyword === selectedKeyword))
                .map((item) => item.date),
              yAxis: data?.content
                .filter((item) => (!selectedKeyword ? true : item.keyword === selectedKeyword))
                .map((item) => item.count),
            },
          }}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Top5Words
          title=""
          content={groupedDataArr}
          clickable={{
            onWordClick: handleWordClick,
            selectedWord: selectedKeyword || "",
          }}
        />
      </Grid>
    </Grid>
  );
};

export default DashboardAreaChartByKeyword;
